<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <menu-sidenav v-if="!$route.meta.public" />

      <div class="layout-container">
        <!-- <Drawer v-if="!$route.meta.public"></Drawer> -->
        <transition name="slide-fade-down">
          <span
            v-show="!online"
            class="bg-dark text-white fixed-top w-full text-center"
          >
            Sem conexão com a internet
          </span>
        </transition>
        <transition name="slide-fade-down">
          <span
            v-show="online && showOnline"
            class="bg-info text-white fixed-top w-full text-center"
          >
            Conectado novamente
          </span>
        </transition>
        <menu-navbar v-if="!$route.meta.public" />

        <div class="layout-content">
          <div
            class="router-transitions container-fluid flex-grow-1 container-p-y"
          >
            <router-view />
          </div>

          <!-- <app-layout-footer /> -->
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
    <bottom-sheet />
  </div>
</template>

<script>
import AppMixin from "./mixins/app"
import BottomSheet from "@/components/BottomSheet"

export default {
  name: "App",
  data() {
    return {
      online: true,
      showOnline: false,
    }
  },
  components: {
    "bottom-sheet": BottomSheet,
  },
  mounted() {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },
  mixins: [AppMixin],
  beforeDestroy() {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav() {
      this.layoutHelpers.setCollapsed(true)
    },
  },
}
</script>

<style>
body {
  background: rgb(241, 241, 241);
}

.VuePagination {
  text-align: center;
}

.vue-title {
  text-align: center;
  margin-bottom: 10px;
}

.vue-pagination-ad {
  text-align: center;
}

.glyphicon.glyphicon-eye-open {
  width: 16px;
  display: block;
  margin: 0 auto;
}

th:nth-child(3) {
  text-align: center;
}

.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}

[v-cloak] {
  display: none;
}
</style>
